import apiClient from './apiClient';

export async function createOrganization(organizationData) {
  return apiClient.post('organizations', organizationData);
}

export async function updateOrganization(orgId, organizationData) {
  if (!orgId) throw new Error("Organization ID is required.");
  return apiClient.put(`organizations/${orgId}`, organizationData);
}